const color = [
  "primary",
  "status-green",
  "status-red",
  "status-yellow",
  "status-orange",
  "status-gray",
  "status-blue",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

const size = [
  "sm",
  "md",
  "lg"
] as const

export default {
  "base": "inline-flex items-center justify-center px-1 rounded-sm font-medium font-sans uppercase",
  "variants": {
    "color": {
      "primary": "",
      "status-green": "",
      "status-red": "",
      "status-yellow": "",
      "status-orange": "",
      "status-gray": "",
      "status-blue": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "size": {
      "sm": "h-4 min-w-[16px] text-[10px]",
      "md": "h-5 min-w-[20px] text-[11px]",
      "lg": "h-6 min-w-[24px] text-[12px]"
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-green"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-red"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-yellow"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-orange"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-gray"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-blue"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-green/50 text-status-green"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-red/50 text-status-red"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-yellow/50 text-status-yellow"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-orange/50 text-status-orange"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-gray/50 text-status-gray"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-blue/50 text-status-blue"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-green bg-status-green/10"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-red bg-status-red/10"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-yellow bg-status-yellow/10"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-orange bg-status-orange/10"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-gray bg-status-gray/10"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-blue bg-status-blue/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-green ring ring-inset ring-status-green/25 bg-status-green/10"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-red ring ring-inset ring-status-red/25 bg-status-red/10"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-yellow ring ring-inset ring-status-yellow/25 bg-status-yellow/10"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-orange ring ring-inset ring-status-orange/25 bg-status-orange/10"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-gray ring ring-inset ring-status-gray/25 bg-status-gray/10"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-blue ring ring-inset ring-status-blue/25 bg-status-blue/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated"
    }
  ],
  "defaultVariants": {
    "variant": "outline" as typeof variant[number],
    "color": "neutral" as typeof color[number],
    "size": "md" as typeof size[number]
  }
}